import React from 'react'
import { string } from 'prop-types'
import Textbox from '@taglivros/oef_componentes/build/components/textbox'

const CodigoBoleto = ( { codigoBarrasBoleto } ) => {
  return (
    <Textbox
      buttonValue="Copiar"
      isCopy
      label="Código do boleto"
      name="codigo-boleto"
      tipo="text"
      value={ codigoBarrasBoleto }
    />
  )
}

CodigoBoleto.propTypes = {
  'codigoBarrasBoleto': string.isRequired
}

export default CodigoBoleto


